// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","box":"Footer_box__dEhGI"};